// 🔹 InquiryCategories.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CategorySection = ({ inquiry, setCat, setShowCategoryModal, setShowCategoryDropdown }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const data = new FormData();
    data.append("uid", "ss");
    data.append("status", "enable")
    axios({
      method: "post",
      url: "/pro/cat/maincat.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        const a = s.data;
        setCategories(Array.isArray(a) ? a : []);
      })
      .catch(() => setCategories([]));

  }, []);

  return (
<div className="row g-3 mt-4 justify-content-center">
  {inquiry == false && <h5>We deals in the below categories:</h5>}  
  {categories.map((category, index) => (
    <div
      key={index}
      className="col-6 col-md-3 d-flex"
    >
      <div
        className="d-flex flex-column align-items-center justify-content-center main-heading-style w-100"
        style={{
          borderRadius: "12px",
          padding: "20px 10px",
          cursor: "pointer",
          transition: "all 0.3s ease-in-out",
          backgroundColor: "#fff",
          height: "100%",
          textAlign: "center",
        }}
        onClick={(e) => {
            if (inquiry !== true) {
                setCat(category.id); // ← important for non-inquiry flow
                setShowCategoryModal(false);
                setShowCategoryDropdown(true);
              } else {
                e.preventDefault();
                localStorage.setItem("title", category.title);
                window.location.assign("/sub/" + category.bread_crumbs);
              }
          
        }}
      >
        <div style={{ fontSize: "32px", marginBottom: "4px" }}>
          <i className={`fas ${category.icon}`} />
        </div>
        <div
          style={{
            fontSize: "15px",
            fontWeight: "600",
            lineHeight: "1.3",
          }}
        >
          {category.title}
        </div>
      </div>
    </div>
  ))}
</div>

  );
};

export default CategorySection;